import styled from 'styled-components'
import { colors } from 'const/colors'
import Icon from 'ui/atoms/Icon'
import { Button } from 'syf-component-library/ui/atoms'

export const Item = styled.section`
  font-size: 14px;
  border-bottom: 1px solid ${colors.greyFifty};

  &:first-child {
    border-top: 1px solid ${colors.greyFifty};
  }
`

export const Header = styled.h3`
  width: 100%;
  margin: 0;
`

export const HeaderButton = styled(Button)`
  width: 100%;
  height: 100%;
  display: flex;
  margin: 0;
  padding: 16px 0;
  justify-content: space-between;
  background: none;
  border: none;
  color: ${colors.greyEighty};

  :hover {
    text-decoration: none;
  }
`

export const ArrowIcon = styled(Icon)<{ $isItemActive: boolean }>`
  ${({ $isItemActive }): string =>
    $isItemActive && 'transform: rotate(180deg);'};
`

export const Content = styled.div`
  padding: 16px 0 32px 0;
`
